import { Checkbox, CheckboxGroup, Spacing, Text } from '@billy/design-system'
import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ExportExtensionsTypes } from '../../types/exportExtensionsTypes'

interface ExportModalCheckboxGroupProps {
  selectedExportExtensions: ExportExtensionsTypes[]
  setSelectedExportExtensions: Dispatch<SetStateAction<ExportExtensionsTypes[]>>
}

export const ExportModalCheckboxGroup = ({
  selectedExportExtensions,
  setSelectedExportExtensions,
}: ExportModalCheckboxGroupProps) => {
  const { t } = useTranslation()

  const handleCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, currentExtension: ExportExtensionsTypes) => {
      setSelectedExportExtensions((prevState) =>
        event.target.checked
          ? [...prevState, currentExtension]
          : prevState.filter((extension) => extension !== currentExtension),
      )
    },
    [setSelectedExportExtensions],
  )

  return (
    <CheckboxGroup spacing={Spacing.S32}>
      <Checkbox
        checked={selectedExportExtensions.includes('pdf')}
        onChange={(event) => handleCheckboxChange(event, 'pdf')}
      >
        <Text>{t('vat_declarations.export_modal.checkbox.pdf')}</Text>
      </Checkbox>
      <Checkbox
        checked={selectedExportExtensions.includes('xlsx')}
        onChange={(event) => handleCheckboxChange(event, 'xlsx')}
      >
        <Text>{t('vat_declarations.export_modal.checkbox.excel')}</Text>
      </Checkbox>
      <Checkbox
        checked={selectedExportExtensions.includes('csv')}
        onChange={(event) => handleCheckboxChange(event, 'csv')}
      >
        <Text>{t('vat_declarations.export_modal.checkbox.csv')}</Text>
      </Checkbox>
    </CheckboxGroup>
  )
}
